module.exports = __webpack_public_path__ + "static/img/0541_7.f96d669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_7.jpg
// module id = tfDJ
// module chunks = 1